module.exports = "<footer class=\"main-footer\">\r\n  <strong class=\"pull-right hidden-xs\" [innerHTML]=\"messages.copyright\"></strong>\r\n  <div>\r\n    <b>{{messages.version}}</b> {{version}}\r\n  </div>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/footer/footer.component.html
// module id = ./src/app/shared/components/footer/footer.component.html
// module chunks = main